import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { PalletCapacityAdapter } from './dto/pallet-capacity.adapter';
import { PalletCapacityController } from './pallet-capacity.controller';
import { PalletCapacity } from './pallet-capacity.entity';
import { PalletCapacityService } from './pallet-capacity.service';

@Module({
  imports:[TypeOrmModule.forFeature([PalletCapacity])],
  controllers: [PalletCapacityController],
  providers: [PalletCapacityService,PalletCapacityAdapter,ApplicationExceptionHandler,LogsService]
})
export class PalletCapacityModule {}
